var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "团队模板",
        width: 600,
        maskClosable: false,
        destroyOnClose: true,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: "模板名称" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "title",
                      {
                        rules: [
                          { required: true, message: "请输入模板名称" },
                          { max: 20, message: "模板名称不能超过20字" },
                        ],
                        initialValue: _vm.formData.title,
                      },
                    ],
                    expression:
                      "[\n          'title',\n          {\n            rules: [\n              { required: true, message: '请输入模板名称' },\n              { max: 20, message: '模板名称不能超过20字' }\n            ],\n            initialValue: formData.title\n          }\n        ]",
                  },
                ],
                attrs: { placeholder: "请输入模板名称" },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "模板内容" } },
            [
              _c("a-textarea", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "content",
                      {
                        rules: [
                          { required: true, message: "请输入模板内容" },
                          { max: 1000, message: "模板内容不能超过1000字" },
                        ],
                        initialValue: _vm.formData.content,
                      },
                    ],
                    expression:
                      "[\n          'content',\n          {\n            rules: [\n              { required: true, message: '请输入模板内容' },\n              { max: 1000, message: '模板内容不能超过1000字' }\n            ],\n            initialValue: formData.content\n          }\n        ]",
                  },
                ],
                attrs: {
                  rows: 6,
                  placeholder: "请输入模板内容，可以是预设的问题或指令",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }